import { render } from "./FormNoSave.vue?vue&type=template&id=ae7a0886&scoped=true"
import script from "./FormNoSave.vue?vue&type=script&lang=js"
export * from "./FormNoSave.vue?vue&type=script&lang=js"

import "./FormNoSave.vue?vue&type=style&index=0&id=ae7a0886&scoped=true&lang=css"

import exportComponent from "/var/www/boa/bo/frontend/boa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae7a0886"]])

export default __exports__